// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"a330db4c","345":"d3f64350","420":"16568459","478":"44ff5c7f","495":"105d17f6","512":"22deb339","536":"a6eac705","550":"94ed2857","628":"237af93c","673":"2175f964","850":"65293af7","878":"2f146cfa","925":"4d67b63b"}[chunkId] + ".chunk.js";
};